import React from "react";
import default_user from "../assets/img/default_user.jpg";
import { Pointer } from "lucide-react";
import { Hidden } from "@material-ui/core";
import { getInitials } from "utils/helpers";

const Profile: React.FC<{ onClick: () => void; name: string; role: string }> = ({
  onClick,
  name,
}) => {
  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      gap: "0.5rem", // gap-2
    },
    avatar: {
      width: "40px", // w-10
      height: "40px", // h-10
      borderRadius: "50%", // rounded-full
    },
    info: {
      display: "flex",
      flexDirection: "column" as const,
    },
    name: {
      fontWeight: 500, // font-medium
      fontSize: "0.875rem", // text-sm
      margin: 0,
    },
    role: {
      fontSize: "0.75rem", // text-xs
      color: "#6b7280", // text-gray-500
      margin: 0,
    },
  };

  return (
    <div style={styles.container}>
      <div>
        {/* Full name on md and up */}
        <Hidden smDown>
          <div
            style={{
              ...styles.info,
              cursor: "pointer" ,
            }}
            onClick={onClick}
          >
            <span style={{ ...styles.name }}>{name}</span>
          </div>
        </Hidden>

        {/* Rounded initials on xs and sm */}
        <Hidden mdUp>
          <div
            style={{
              ...styles.info,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "#dfdfdf",
              fontWeight: "bold",
              fontSize: "14px",
              cursor:  "pointer",
            }}
            onClick={onClick}
          >
            {getInitials(name)}
          </div>
        </Hidden>
      </div>
    </div>
  );
};

export default Profile;
